// data/books.js

const booksData = [
    {
        _id: "64f4c01560c01f9e5847046f",
        title: "Disciple for Purpose",
        image:
            "https://res.cloudinary.com/dngkojo9y/image/upload/v1693761214/discipline_crtrhb.jpg",
        author: "God's Women of Purpose",
        content:
            "Disciple for purpose helps to promote self-discipline. Respect for oneself, others, authority and property, and the maintenance of a safe and healthy environment.",
        link:
            "https://docs.google.com/file/d/1wrSSc65OyiarufgLsrwnVABThL7Cvosm/edit?usp=docslist_api&filetype=mspresentation",
        createdAt: "2023-09-03T17:14:22.584Z",
    },
    {
        _id: "64f4c18360c01f9e58470475",
        title: "Marriage Planner",
        image:
            "https://res.cloudinary.com/dngkojo9y/image/upload/v1693761906/book3_e3ni5p.jpg",
        author: "Joy Agunbiade",
        content:
            "Marital planning provides an opportunity to discuss these issues beforehand, see if both parties are on the same page and, more importantly, set expectations and plan how to address expectations that are not met.",
        link:
            "https://docs.google.com/document/d/1uJHapz4WxaCx6kUdQSDchw9eK_KNAoiW86noOUxJHs0/edit#heading=h.nj23sjpj5u97",
        createdAt: "2023-09-03T17:14:22.584Z",
    },
];

export default booksData;